function isTouchOrPen(event) {
  return event.pointerType !== "mouse";
}

export { isTouchOrPen as i };
//# sourceMappingURL=utils.js.map
